import './index.css'
import * as React from 'react'
import type { CSSProperties } from 'react'
import type { PopoverItemType } from 'types/ui'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import type { PlaylistTheme } from 'types/playlist'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import EllipsisMenu from 'components/ui/ellipsis-menu'
import { RadioButton } from 'components/ui/radio'
import modalStyles from 'components/utils/modalStyles'
import EditTheme from '../edit-theme'

class Theme extends React.Component<
  {
    theme: PlaylistTheme
    labelMark?: boolean
    isSelected: boolean
    updateTheme: (...args: Array<any>) => any
    deleteTheme: (...args: Array<any>) => any
    createTheme: (...args: Array<any>) => any
    onSelect?: () => unknown
    disabled?: boolean
    isPhone: boolean
  },
  {
    modalOpen: boolean
  }
> {
  constructor(props: any) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  _openModal = () => {
    this.setState({
      modalOpen: true,
    })
  }
  _closeModal = () => {
    this.setState({
      modalOpen: false,
    })
  }
  _onActionClick = action => {
    switch (action) {
      case 'Default':
        this.props.updateTheme({
          savedTheme: this.props.theme,
          theme: {
            name: this.props.theme.name,
            defaultTheme: !this.props.theme.default,
          },
        })
        break

      case 'Delete':
        this.props.deleteTheme(this.props.theme)
        break

      case 'Edit':
        this._openModal()

        break

      default:
        throw new Error('Not implemented')
    }
  }

  render() {
    const { image, name, logo, default: defaultTheme } = this.props.theme
    const themeStyle: CSSProperties = {
      backgroundImage: image ? `url("${image}")` : undefined,
    }
    const logoStyle: CSSProperties = {
      backgroundImage: logo ? `url("${logo}")` : undefined,
    }
    const defaultLabel =
      defaultTheme && this.props.labelMark ? (
        <div className="Theme_DefaultLabel">Default</div>
      ) : null
    let modal: React.ReactNode = null

    if (this.state.modalOpen) {
      modal = (
        <Modal onRequestClose={this._closeModal} style={modalStyles} isOpen>
          <EditTheme theme={this.props.theme} closeModal={this._closeModal} />
        </Modal>
      )
    }

    /* const creator =
      'User ' +
      ((this.props.theme.owner || '').split('/user/')[1] || '').replace('/', '') */
    let options: PopoverItemType[] = []

    if (!this.props.disabled) {
      options.push({
        label: 'Edit theme',
        value: 'Edit',
        disabled: this.props.isPhone,
      })
      options.push({
        label: defaultTheme ? 'Remove as default' : 'Make default',
        value: 'Default',
      })
    }

    options.push({
      label: 'Delete theme',
      value: 'Delete',
      destructive: true,
    })
    return (
      <div className="Theme" onClick={this.props.onSelect}>
        <div onClick={e => e.stopPropagation()}>{modal}</div>
        <div className="Theme_Content_Bg" style={themeStyle}>
          <div className="Theme_Content_Logo" style={logoStyle} />
        </div>
        <div className="Theme_Details">
          <div className="Theme_Details_Name">{name}</div>
        </div>
        {this.props.onSelect ? (
          <RadioButton checked={this.props.isSelected} />
        ) : (
          <React.Fragment>
            {defaultLabel}
            <EllipsisMenu
              compact
              options={options}
              icon="ellipsis"
              hasArrow={false}
              onOptionClick={this._onActionClick}
            />
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default connect(state => {
  return {
    isPhone: isDeviceTypePhone(state),
  }
})(Theme) as any
